<div class="theme-settings">
  <h1>{{ 'SETTINGS.THEME.TITLE' | translate }}</h1>

  <div class="theme-section">
    <div class="theme-card">
      <div class="card-section">
        <h3>{{ 'SETTINGS.THEME.COLORS.THEME_COLORS' | translate }}</h3>
        <div class="color-display">
          <div class="color-item">
            <div class="color-label">{{ 'SETTINGS.THEME.COLORS.HEADER_COLOR' | translate }}</div>
            <div class="color-preview" [style.background]="selectedHeaderColor()"></div>
          </div>
          <div class="color-item">
            <div class="color-label">{{ 'SETTINGS.THEME.COLORS.BUTTON_COLOR' | translate }}</div>
            <div class="color-preview" [style.background]="selectedButtonColor()"></div>
          </div>
          <div class="color-item">
            <div class="color-label">{{ 'SETTINGS.THEME.COLORS.BUTTON_HOVER_COLOR' | translate }}</div>
            <div class="color-preview" [style.background]="selectedButtonHoverColor()"></div>
          </div>
          <div class="color-item">
            <div class="color-label">{{ 'SETTINGS.THEME.COLORS.BUTTON_LABEL_COLOR' | translate }}</div>
            <div class="color-preview" [style.background]="selectedButtonLabelColor()"></div>
          </div>
          <div class="color-item">
            <div class="color-label">{{ 'SETTINGS.THEME.COLORS.CLIENT_BUTTON_COLOR' | translate }}</div>
            <div class="color-preview" [style.background]="selectedClientButtonColor()"></div>
          </div>
          <div class="color-item">
            <div class="color-label">{{ 'SETTINGS.THEME.COLORS.CLIENT_BUTTON_HOVER_COLOR' | translate }}</div>
            <div class="color-preview" [style.background]="selectedClientButtonHoverColor()"></div>
          </div>
          <div class="color-item">
            <div class="color-label">{{ 'SETTINGS.THEME.COLORS.CLIENT_BUTTON_LABEL_COLOR' | translate }}</div>
            <div class="color-preview" [style.background]="selectedClientButtonLabelColor()"></div>
          </div>
          <div class="color-item">
            <div class="color-label">{{ 'SETTINGS.THEME.COLORS.SENDER_CHAT_BUBBLE_COLOR' | translate }}</div>
            <div class="color-preview" [style.background]="selectedSenderChatBubbleColor()"></div>
          </div>
          <div class="color-item">
            <div class="color-label">{{ 'SETTINGS.THEME.COLORS.PARTICIPANT_CHAT_BUBBLE_COLOR' | translate }}</div>
            <div class="color-preview" [style.background]="selectedParticipantChatBubbleColor()"></div>
          </div>
          <div class="color-item">
            <div class="color-label">{{ 'SETTINGS.THEME.COLORS.SENDER_CHAT_BUBBLE_TEXT_COLOR' | translate }}</div>
            <div class="color-preview" [style.background]="selectedSenderChatBubbleTextColor()"></div>
          </div>
          <div class="color-item">
            <div class="color-label">{{ 'SETTINGS.THEME.COLORS.PARTICIPANT_CHAT_BUBBLE_TEXT_COLOR' | translate }}</div>
            <div class="color-preview" [style.background]="selectedParticipantChatBubbleTextColor()"></div>
          </div>
          <div class="color-item">
            <div class="color-label">{{ 'SETTINGS.THEME.COLORS.CLIENT_SENDER_CHAT_BUBBLE_COLOR' | translate }}</div>
            <div class="color-preview" [style.background]="selectedClientSenderChatBubbleColor()"></div>
          </div>
          <div class="color-item">
            <div class="color-label">{{ 'SETTINGS.THEME.COLORS.CLIENT_PARTICIPANT_CHAT_BUBBLE_COLOR' | translate }}</div>
            <div class="color-preview" [style.background]="selectedClientParticipantChatBubbleColor()"></div>
          </div>
          <div class="color-item">
            <div class="color-label">{{ 'SETTINGS.THEME.COLORS.CLIENT_SENDER_CHAT_BUBBLE_TEXT_COLOR' | translate }}</div>
            <div class="color-preview" [style.background]="selectedClientSenderChatBubbleTextColor()"></div>
          </div>
          <div class="color-item">
            <div class="color-label">{{ 'SETTINGS.THEME.COLORS.CLIENT_PARTICIPANT_CHAT_BUBBLE_TEXT_COLOR' | translate }}</div>
            <div class="color-preview" [style.background]="selectedClientParticipantChatBubbleTextColor()"></div>
          </div>
          <orbit-button
            [label]="'SETTINGS.GENERAL.EDIT' | translate"
            [icon]="editIcon"
            (onClick)="openColorPickerDialog()" />
        </div>
      </div>
    </div>
  </div>
</div> 